import { Component } from '@angular/core';
import { ErrorComponent } from '@atoms/error/error.component';
import { SharedCommonModule } from '../../common.module';

@Component({
  selector: 'edu-forbidden-page',
  templateUrl: './forbidden.component.html',
  imports: [SharedCommonModule, ErrorComponent],
})
export class ForbiddenPageComponent {}
